import router from "../router/router";
import type { AnalyticsEventMap } from "./events";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = "G-MQREBZH4VC";

const isAnalyticsEnabled = () => import.meta.env.VITE_APP_PHASE === "production";

export const trackPageView = (path: string) => {
  if (!isAnalyticsEnabled()) {
    return;
  }

  window.gtag?.("config", GA_MEASUREMENT_ID, { page_path: path });
};

export function trackEvent<E extends keyof AnalyticsEventMap>(
  ...args: AnalyticsEventMap[E] extends undefined
    ? [event: E]
    : [event: E, params: AnalyticsEventMap[E]]
): void {
  if (!isAnalyticsEnabled()) {
    return;
  }

  const [event, params] = args;
  window.gtag?.("event", event, params);
}

export const initAnalytics = () => {
  if (!isAnalyticsEnabled()) {
    return;
  }

  if (window.gtag) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer!.push(arguments as unknown as unknown[]);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  trackPageView(`${window.location.pathname}${window.location.search}`);

  router.subscribe(({ location }) => {
    trackPageView(`${location.pathname}${location.search}`);
  });
};
